// extracted by mini-css-extract-plugin
export var ButtonContainer = "ContactForm-module--ButtonContainer--a3d52";
export var ButtonSubmitting = "ContactForm-module--ButtonSubmitting--4d492";
export var ButtonSuccess = "ContactForm-module--ButtonSuccess--22778";
export var DobleInput = "ContactForm-module--DobleInput--5d2ac";
export var FormContainer = "ContactForm-module--FormContainer--75949";
export var SectionForm = "ContactForm-module--SectionForm--64b5d";
export var SimpleInput = "ContactForm-module--SimpleInput--9c9db";
export var box = "ContactForm-module--box--dc36a";
export var box2 = "ContactForm-module--box2--3a093";
export var box3 = "ContactForm-module--box3--e5a4e";
export var customFile = "ContactForm-module--custom-file--2f3cd";
export var customFileInput = "ContactForm-module--custom-file-input--d0f88";
export var customFileLabel = "ContactForm-module--custom-file-label--e8f81";
export var errorMessage = "ContactForm-module--errorMessage--76cc0";
export var loader = "ContactForm-module--loader--cf5da";
export var rotation = "ContactForm-module--rotation--32e5d";
export var title = "ContactForm-module--title--e3c8d";